module.exports = __webpack_public_path__ + "3d9939a52b97a32a0ff281869621e2dd.svg";